import { gql } from '@apollo/client';

export const FILTERED_SUBJECTS = gql`
  query FilteredSubjects($input: SubjectGradeFilter!) {
    filteredSubjects(input: $input) {
      id
      name
      subjectGradeReference
    }
  }
`;
